import { Text, Box, PopoverBody, Popover, PopoverTrigger, PopoverContent } from '@chakra-ui/react'
// 型エラー回避のための型アサーション
import * as MdIcons from "react-icons/md";

type CommentPopoverProps = {
    comment: string
}

export const CommentPopover = ({comment}: CommentPopoverProps) => {
    // 動的にアイコンを取得
    const MdComment = (MdIcons as any).MdComment;

    return (
        <Popover trigger="hover">
            <PopoverTrigger>
                <Box>
                    <MdComment size="20px" />
                </Box>
            </PopoverTrigger>
            <PopoverContent w='300px' alignItems='start'>
                <PopoverBody>
                    <Box maxH='200px' overflowY='scroll'>
                        <Text m={0} whiteSpace='pre-wrap'>{comment}</Text>
                    </Box>
                </PopoverBody>
            </PopoverContent>
        </Popover>
    )
}